import { useState } from "react"
import { ProductManufacturerItem } from "api/ProductManufacturers"

interface ManufacturerAccordionProps {
    data: ProductManufacturerItem[];
    setSelectedManufacturer?: (id: number | null) => void;
}

export default function ManufacturerAccordion({ data, setSelectedManufacturer }: ManufacturerAccordionProps) {
    const [accordionOpen, setAccordionOpen] = useState(true)
    const [activeId, setActiveId] = useState<number | null>(null)

    const toggleAccordion = () => {
        setAccordionOpen(prev => !prev)
    }

    const handleSelect = (id: number) => {
        const newId = activeId === id ? null : id;
        setActiveId(newId);
        if (setSelectedManufacturer) setSelectedManufacturer(newId);
    }

    return (
        <div className="MuiPaper-root MuiAccordion-root filter-product-accordion Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded">
            <button className="styles_accordionHeader__xUFrY" onClick={toggleAccordion}>
                <p>Nhà sản xuất</p>
                <span className={[accordionOpen ? "styles_buttonExpand__QQLBp styles_buttonExpanded__jSTHs" : "styles_buttonExpand__QQLBp"].join(" ")}>
                    <svg
                        className="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >
                        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>
                </span>
            </button>

            {accordionOpen && (
                <div
                    className="MuiCollapse-root MuiCollapse-entered"
                    style={{ minHeight: "0px" }}
                >
                    <div className="MuiCollapse-wrapper">
                        <div className="MuiCollapse-wrapperInner">
                            <div role="region">
                                <div
                                    className="MuiAccordionDetails-root accordion-detail"
                                    style={{ display: "block" }}
                                >
                                    <div className="styles_containerList__c3d5v styles_itemList__qvTM4">
                                        {data && data.length > 0 ? (
                                            data.map((item) => (
                                                <div key={item.id} style={{ width: "100%" }}>
                                                    <button
                                                        className={[
                                                            "styles_item__rQ1Ka",
                                                            activeId === item.id && "styles_activeItem__7Yk8F"
                                                        ].filter(Boolean).join(" ")}
                                                        onClick={() => handleSelect(item.id)}
                                                    >
                                                        <span>{item.name}</span>
                                                    </button>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="p-2 text-center text-gray-400 text-sm">
                                                Không có dữ liệu
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
